import React, { useState } from 'react';

interface FAQItem {
  id: number;
  question: string;
  answer: string;
  category: string;
}

const FAQPage: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [openItems, setOpenItems] = useState<number[]>([]);

  const faqData: FAQItem[] = [
    // 상품 예약·수령
    {
      id: 1,
      question: "렌즈는 어떻게 구매하나요?",
      answer: "폰피쉬의 모든 상품은 온라인 예약 후, 선택한 매장에서 결제 및 수령하는 방식으로 제공됩니다.\n원하는 렌즈를 예약하면, 상품이 해당 매장으로 배송되며 매장 방문 시 예약자 정보로 확인 후 결제·수령 가능합니다.\n\n※ 예약 없이 매장을 방문하실 경우 렌즈 구매는 불가하니 반드시 예약을 먼저 진행해 주세요.",
      category: "상품 예약·수령"
    },
    {
      id: 2,
      question: "예약한 렌즈는 언제 받을 수 있나요?",
      answer: "예약 완료 후, 상품은 영업일 기준 약 1~3일 내 선택한 매장으로 배송됩니다.\n배송이 시작되면 배송 시작 알림톡이 발송되며, 매장 도착 시 픽업 안내 메시지가 전송됩니다.\n\n※ 택배사 사정에 따라 일정이 달라질 수 있습니다.",
      category: "상품 예약·수령"
    },
          {
        id: 3,
        question: "예약한 방문 일정을 변경할 수 있나요?",
        answer: "상품은 매장 도착 후 15일 이내 수령 가능합니다.\n기간 내 수령하지 않을 경우 예약은 자동 취소될 수 있으며, 15일 이후 수령을 원하실 경우 매장으로 직접 문의 부탁드립니다.",
        category: "상품 예약·수령"
      },
          {
        id: 4,
        question: "예약을 변경하거나 취소하려면 어떻게 하나요?",
        answer: "예약 상품은 변경이 불가합니다.\n렌즈 종류·도수·예약 매장을 바꾸고 싶으실 경우 기존 예약을 취소 후 재예약해 주세요.\n예약 취소는 예약 수락 전까지 가능하며, 상품이 이미 매장으로 배송된 경우에는 고객센터를 통해 취소 접수가 가능합니다.\n\n※ 예약 시 결제가 발생하지 않으므로 취소 시 별도의 환불 절차는 없습니다.",
        category: "상품 예약·수령"
      },
          {
        id: 5,
        question: "택배 배송으로 받을 수 있나요?",
        answer: "국내 의료기기 법령에 따라 렌즈는 반드시 인허가된 안경원에서만 판매가 가능합니다.\n따라서 택배 수령은 불가하며, 예약 후 매장에서만 결제·수령이 가능합니다.\n\n※ 교환/반품 시에도 동일하게 택배 발송은 불가합니다.",
        category: "상품 예약·수령"
      },
    {
      id: 6,
      question: "다른 사람이 대신 구매할 수 있나요?",
      answer: "렌즈는 의료기기로 원칙상 대리 구매가 불가합니다.",
      category: "상품 예약·수령"
    },
    // 교환·환불
          {
        id: 7,
        question: "렌즈가 불량인 것 같아요.",
        answer: "불량 제품의 교환 및 환불은 상품 도착일로부터 30일 이내 가능하며, 폰피쉬 고객센터(카카오톡 채널 @ponpish)로 접수해 주셔야 합니다.\n교환/환불은 예약 시 선택하신 매장에서만 가능하며, 매장 변경은 불가합니다.\n개봉 후에는 제조 불량인 경우에 한해서만 교환 및 환불이 가능합니다.\n교환 시 동일 품목·색상으로만 교환되며, 다른 상품을 원하실 경우 환불 처리 됩니다.\n\n접수 시 필요한 정보:\n① 예약번호 + 예약자 성함\n② 제품명/도수/수량(팩단위)\n③ 요청 내용\n④ 불량 상품 사유 기재\n⑤ 사진 첨부(렌즈 및 패키지 LOT번호)",
        category: "교환·환불"
      },
          {
        id: 8,
        question: "교환/환불을 받고 싶어요.",
        answer: "교환 및 환불은 상품 도착일로부터 15일 이내 가능하며, 반드시 폰피쉬 고객센터를 통해 접수해 주세요.\n미개봉 상품에 한해 도수 교환만 가능하며, 색상 또는 타 제품 교환은 환불 후 재예약이 필요합니다.\n개봉 후에는 제조 불량에 한해서만 교환/환불이 가능합니다.\n단순 변심에 의한 부분 환불은 불가하며, 환불 진행 시 쿠폰/할인 적용 전 금액 기준으로 환불됩니다.\n\n접수 시 필요한 정보:\n① 예약번호 + 예약자 성함\n② 제품명/도수/수량(팩단위)\n③ 요청 내용\n④ 사유 기재\n⑤ 사진 첨부(미개봉 사진 필수)\n\n※ 컬러 변경, 타 제품 변경, 품절 도수 요청은 교환이 불가하며, 해당 항목 기재 시 자동으로 반품 접수 처리됩니다. (원데이 ⇄ 원먼스 간의 교환 불가)\n※ 반품 시 사용한 포인트와 쿠폰은 순차적으로 복구되나, 유효기간이 지난 쿠폰은 재발급되지 않으며 시스템 상황에 따라 일부 복구가 어려울 수 있습니다.",
        category: "교환·환불"
      },
    // 렌즈 정보
          {
        id: 9,
        question: "내 시력에 맞는 도수는 어떻게 확인하나요?",
        answer: "폰피쉬 예약 시 도수는 반드시 6개월 이내 안경원/안과 처방 기준이어야 합니다.\n\n※ 도수 확인이 필요하실 경우, 예약 전 가까운 안경원에서 검안을 권장합니다.",
        category: "렌즈 정보"
      },
          {
        id: 10,
        question: "좌/우 눈 도수가 다른 경우 어떻게 예약하나요?",
        answer: "좌우 도수가 다르실 경우, 각각 1팩씩 총 2팩을 예약해 주세요.\n\n※ 한 팩 내에서 좌우 다른 도수 선택은 불가합니다.",
        category: "렌즈 정보"
      },
          {
        id: 11,
        question: "원하는 도수가 없는 경우 어떻게 하나요?",
        answer: "컬러렌즈는 최대 -8.00 도수까지 예약 가능합니다.\n-0.75는 제공되지 않으며, 인접 도수인 -0.50 또는 -1.00을 선택해 주세요.\n\n※ 도수 선택은 반드시 전문가의 처방 및 검안을 통해 결정하시길 권장합니다.",
        category: "렌즈 정보"
      },
    {
      id: 12,
      question: "난시용 렌즈도 있나요?",
      answer: "현재 폰피쉬에서는 난시용 렌즈 예약은 제공되지 않습니다.",
      category: "렌즈 정보"
    },
    {
        id: 13,
        question: "렌즈 사용 방법이 궁금해요.",
        answer: "콘택트렌즈는 의료기기로, 반드시 올바른 사용법을 숙지하신 후 사용해야 합니다.\n\n- 렌즈 착용 전 손을 깨끗이 세척하세요.\n- 장시간 착용은 각막 손상 및 감염 위험이 있으므로 권장 사용 시간을 지켜주세요.\n- 물(수영장, 바닷물, 수돗물)과 접촉 시 감염 위험이 있으니 주의하세요.\n- 눈이 불편하거나 충혈, 이물감이 있으면 즉시 렌즈를 제거하고 안과 진료를 받아야 합니다.\n- 콘택트렌즈 관리용품은 식약처 허가 제품을 사용해 세척/소독해야 합니다.",
        category: "렌즈 정보"
      },
    // 서비스 이용
    {
      id: 14,
      question: "서비스 이용 방법은 어떻게 되나요?",
      answer: "서비스 이용을 위해서는 회원가입 후 로그인하여 이용하실 수 있습니다. 자세한 이용 방법은 서비스 이용약관을 참고해 주세요.",
      category: "서비스 이용"
    },
          {
        id: 15,
        question: "서비스 이용 중 오류가 발생하면 어떻게 하나요?",
        answer: "서비스 이용 중 오류가 발생한 경우 고객센터로 문의해 주시거나, 오류 내용을 스크린샷과 함께 보내주시면 빠른 해결을 도와드립니다.\n\n접수 시 필요한 정보:\n① 예약번호 + 예약자 성함\n② 기기 종류 / OS 버전\n③ 앱 버전 또는 사용 브라우저 정보\n④ 오류 발생 화면 및 단계\n⑤ 오류 내용 (오류 메시지 캡처 포함)\n⑥ 발생 시간\n⑦ 스크린샷 또는 화면 녹화 파일",
        category: "서비스 이용"
      },
    {
      id: 16,
      question: "개인정보는 어디서 수정할 수 있나요?",
      answer: "마이페이지 > 개인정보 수정에서 개인정보를 수정할 수 있습니다. 수정 후 저장 버튼을 클릭해 주세요.",
      category: "서비스 이용"
    },
          {
        id: 17,
        question: "회원 탈퇴는 어떻게 하나요?",
        answer: "마이페이지 > 개인정보 수정 > 회원탈퇴에서 회원탈퇴를 진행할 수 있습니다.\n\n탈퇴 시 계정 및 개인 정보, 쿠폰/적립금은 모두 삭제되며 복구가 불가능합니다.\n구매 내역은 전자상거래법에 따라 5년간 보관 후 파기됩니다.\n작성하신 리뷰/게시글은 자동 삭제되지 않으니, 필요한 경우 반드시 탈퇴 전에 직접 삭제해 주세요.\n\n※ 탈퇴 후 재가입은 3개월 이후부터 가능하며, 첫구매 이벤트는 중복 참여가 불가합니다.",
        category: "서비스 이용"
      }
  ];

  const categories = ['all', '상품 예약·수령', '교환·환불', '렌즈 정보', '서비스 이용'];

  const filteredFAQs = selectedCategory === 'all' 
    ? faqData 
    : faqData.filter(faq => faq.category === selectedCategory);

  const toggleItem = (id: number) => {
    setOpenItems(prev => 
      prev.includes(id) 
        ? prev.filter(item => item !== id)
        : [...prev, id]
    );
  };

  return (
    <div className="min-h-screen bg-white py-6">
      <div className="max-w-4xl mx-auto px-2 sm:px-24 lg:px-2">
        <div className="bg-white px-4 py-8">
          <h1 className="text-3xl font-bold text-black mb-8 text-center">
            자주 묻는 질문 (FAQ)
          </h1>

          {/* 카테고리 필터 */}
          <div className="mb-8">
            <div className="flex flex-wrap gap-2 justify-center">
              {categories.map(category => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 rounded-full text-base font-medium transition-colors ${
                    selectedCategory === category
                      ? 'bg-black text-white'
                      : 'bg-gray-200 text-black hover:bg-gray-300'
                  }`}
                >
                  {category === 'all' ? '전체' : category}
                </button>
              ))}
            </div>
          </div>

          {/* FAQ 목록 */}
          <div className="space-y-4">
            {filteredFAQs.map(faq => (
              <div key={faq.id} className="border border-gray-200 rounded-lg">
                <button
                  onClick={() => toggleItem(faq.id)}
                  className="w-full px-4 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
                >
                  <span className="font-medium text-black break-keep break-words pr-1">{faq.question}</span>
                  <span className={`text-gray-600 transition-transform ${
                    openItems.includes(faq.id) ? 'rotate-180' : ''
                  }`}>
                    ▼
                  </span>
                </button>
                {openItems.includes(faq.id) && (
                  <div className="px-4 pb-4 border-t border-gray-200">
                    <p className="text-black pt-4 break-keep break-words whitespace-pre-line">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* 추가 문의 안내 */}
          <div className="mt-12 p-6 bg-gray-100 rounded-lg text-center">
            <h3 className="text-lg font-semibold text-black mb-2">
              더 궁금한 점이 있으신가요?
            </h3>
            <p className="text-black mb-4">
              위 FAQ에서 답변을 찾지 못하셨다면<br />고객센터로 문의해 주세요.
            </p>
            <div className="text-sm text-gray-700 space-y-1">
              <p>이메일: cs@ponpish.kr</p>
              <p>카카오톡 상담: @ponpish</p>
              <p>운영시간: 평일 10:00 - 18:00</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
